// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-1PKA-USH","foot_link":"foot_link-_UOS7Q07","list":"list-1R4c8715","link":"link-34F45EtR","copyright":"copyright-1vZccmlO"};